'use client';

import { VariantProps } from 'tailwind-variants';

import { styles } from './ContentSection.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;
type Variants = VariantProps<typeof styles>;

export interface ContentSectionProps {
  type?: Variants['type'];
  leftBlock?: React.ReactNode;
  rightBlock?: React.ReactNode;
  classNameRightBlock?: string;
  classNameLeftBlock?: string;
  onClick?: NativeElement['onClick'];
}

export function ContentSection({
  leftBlock,
  type,
  rightBlock,
  classNameRightBlock,
  classNameLeftBlock
}: ContentSectionProps) {
  const slots = styles({ type });

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.wrap()}>
          <div className={slots.left({ className: classNameLeftBlock })}>
            {leftBlock}
          </div>
          <div className={slots.right({ className: classNameRightBlock })}>
            {rightBlock}
          </div>
        </div>
      </div>
    </div>
  );
}
